// Megamenu: hover interaction + clickable parent items

document.addEventListener('DOMContentLoaded', function() {
  syncHeaderBottomCssVar();
  initMegaMenuHover();
  initPromoDrag();
});

function syncHeaderBottomCssVar() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;
  document.documentElement.style.setProperty(
    '--header-bottom-position-desktop',
    `${Math.floor(headerWrapper.getBoundingClientRect().bottom)}px`
  );
}

window.addEventListener('resize', syncHeaderBottomCssVar);

(function() {
  const headerObserver = new MutationObserver(() => {
    initMegaMenuHover();
    initPromoDrag();
  });

  const header = document.querySelector('.header-wrapper') || document.querySelector('header');
  if (header) {
    headerObserver.observe(header, { childList: true, subtree: true });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initMegaMenuHover();
      initPromoDrag();
    });
  }
})();

function initMegaMenuHover() {
  const megaMenus = document.querySelectorAll('.header__inline-menu .mega-menu');

  megaMenus.forEach(menu => {
    if (menu.dataset.hoverInit) return;
    menu.dataset.hoverInit = 'true';

    const summary = menu.querySelector('summary');
    const headerMenu = menu.closest('header-menu');
    if (!summary) return;

    let closeTimeout = null;

    if (headerMenu) {
      headerMenu.onFocusOut = function() {};
    }

    menu.addEventListener('mouseenter', function() {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      megaMenus.forEach(m => {
        if (m !== menu) m.removeAttribute('open');
      });
      menu.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', function() {
      closeTimeout = setTimeout(() => {
        menu.removeAttribute('open');
      }, 150);
    });

    summary.addEventListener('click', function(e) {
      const span = e.target.closest('span');
      if (span) {
        const url = summary.getAttribute('data-link-url');
        if (url && url !== '#' && url !== '') {
          window.location.href = url;
          return;
        }
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    summary.addEventListener('mousedown', function(e) {
      e.preventDefault();
    }, true);
  });
}

function initPromoDrag() {
  const promos = document.querySelectorAll('.mega-menu__promo');

  promos.forEach(el => {
    if (el.dataset.dragInit) return;
    el.dataset.dragInit = 'true';

    el.addEventListener('dragstart', e => e.preventDefault());

    let isDragging = false;
    let startX = 0, startScroll = 0;
    let velX = 0, lastX = 0, lastTime = 0;
    let rafId = null;

    el.addEventListener('mousedown', e => {
      if (e.button !== 0) return;

      // If press starts on a link or image, leave it 100% alone — no drag intercept
      if (e.target.closest('a')) return;

      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      isDragging = false;
      startX = e.pageX;
      startScroll = el.scrollLeft;
      velX = 0; lastX = e.pageX; lastTime = Date.now();

      function onMove(me) {
        const dx = me.pageX - startX;
        if (!isDragging && Math.abs(dx) < 4) return;
        if (!isDragging) {
          isDragging = true;
          el.classList.add('is-dragging');
        }
        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) velX = (me.pageX - lastX) / dt;
        lastX = me.pageX; lastTime = now;
        el.scrollLeft = startScroll - dx;
      }

      function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        el.classList.remove('is-dragging');
        if (!isDragging) return;
        isDragging = false;
        let velocity = -velX * 40;
        const friction = 0.94;
        (function momentum() {
          if (Math.abs(velocity) < 0.5) return;
          el.scrollLeft += velocity;
          velocity *= friction;
          rafId = requestAnimationFrame(momentum);
        })();
      }

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  });
}
